import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeamResponse } from 'src/app/models/TeamResponse';
import { CommonResponse } from 'src/app/models/commomResponse';
import { driverData } from 'src/app/models/driverData';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { OrderDetail } from 'src/app/models/orderDetail';
import { orderToDriver, orderUpdatePayload } from 'src/app/models/orderPayload';
import { OrderResponse } from 'src/app/models/orderResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) {}

  getOrder(query: string): Observable<OrderResponse> {
    return this.http
      .get<{ data: OrderResponse }>(`${environment.base_url}/factory/getOrders?${query}`)
      .pipe(map(res => res.data));
  }

  getreturnRequest(query: string): Observable<OrderResponse> {
    return this.http
      .get<{
        data: OrderResponse;
      }>(`${environment.base_url}/factory/returnRequest?${query}`)
      .pipe(map(res => res.data));
  }

  getTeams(): Observable<Array<TeamResponse>> {
    return this.http
      .get<{
        data: Array<TeamResponse>;
      }>(`${environment.base_url}/factory/teamsDropdown`)
      .pipe(map(res => res.data));
  }

  updateOrder(
    orderId: string,
    body: orderUpdatePayload
  ): Observable<OrderDetail> {
    return this.http
      .put<{
        data: OrderDetail;
      }>(`${environment.operational_url}updateOrder/${orderId}? `, body)
      .pipe(map(res => res.data));
  }

  assignDriver(
    orderId: string,
    body: { driverId: string; bookingForReturnDriver?: boolean }
  ): Observable<CommonResponse> {
    return this.http
      .post<{
        data: CommonResponse;
      }>(`${environment.operational_url}assignOrder/${orderId}`, body)
      .pipe(map(res => res.data));
  }

  getDriversByTeam(id: string): Observable<{ data: Array<driverData> }> {
    return this.http.get<{ data: Array<driverData> }>(
      `${environment.base_url}/factory/driversThroughTeam/${id}`
    );
  }
  
  assignOrderToDriver(
    payload: orderToDriver,
    orderId: string
  ): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}/factory/assignDriver/${orderId}`,
      payload
    );
  }

  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}/factory/admin/getOrdersCsvExport?${query}`
    );
  }

  invoice(orderId: string): Observable<any> {
    return this.http.get<any>(`${environment.operational_url}invoice/${orderId}`);
  }
}
